import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import pkg from 'package.json'
import {DadosJwtService} from "../../../core/services/dados-jwt.service";
@Component({
  selector: 'app-menu-user-avatar',
  templateUrl: './menu-user-avatar.component.html',
  styleUrls: ['./menu-user-avatar.component.scss']
})

export class MenuUserAvatarComponent implements OnInit {
  version = pkg.version
  podeVerbotaoAvatar = false;
  nomeUsuario = '';

  constructor(
    public authService: AuthService,
    public dadosJwtService: DadosJwtService,
    ) {
  }

  ngOnInit(): void {
    this.verificaSePodeVerBotaoAvatar();
    this.nomeUsuario = this.dadosJwtService.get().nome ?? '';
  }

  verificaSePodeVerBotaoAvatar(){
    let auth = this.dadosJwtService.get();
    if(auth){
      this.podeVerbotaoAvatar = true;
    }
  }

  gerarIniciaisNome(): string{
    let nome = this.nomeUsuario.toLowerCase();
    let sigla = '';
    let temMaisDeUmaPalavra = (nome.indexOf(' ') >= 0) ? true : false;

    // Se o nome tem mais de uma palavra, retorna as letras iniciais da primeira e da ultima palavra;
    if(temMaisDeUmaPalavra){
      let letrasIniciais = nome.match(/\b(\w)/gi); // Iniciais de cada parte do nome.
      let primeiraLetra = nome.substr(0, 1);
      let segundaLetra = letrasIniciais![letrasIniciais!.length - 1];
      sigla = primeiraLetra + segundaLetra;
    }

    // Se o nome tem apenas uma palavra, retorna as 2 letras inicias
    else{
      sigla = nome.substr(0, 2);
    }

    return sigla.toUpperCase();
  }


}
